var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.408.001C15.345.001 13.071 1.26 12 4.022 10.945 1.303 8.729.065 6.72.065 3.877.064 1 2.504 1 7.166c0 8.455 10.286 15.355 10.725 15.644.083.056.18.083.275.083.108 0 .216-.035.306-.104C12.743 22.451 23 14.421 23 6.574 23 2.258 20.187.001 17.408.001zM11.977 21.77C10.288 20.57 2 14.317 2 7.166c0-4.192 2.446-6.102 4.72-6.102 1.854 0 4.219 1.308 4.786 4.994.037.244.247.424.494.424s.457-.18.494-.424C13.068 2.325 15.5 1 17.408 1 19.62 1 22 2.745 22 6.574c0 6.659-8.361 13.837-10.023 15.196z"}));
}

Heart.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Heart;

Heart.default = Heart;
